module.exports = __webpack_public_path__ + "static/media/365Bar.734c3955.svg";